import { notifications } from '@mantine/notifications';

const getStyles = (type: 'success' | 'danger') => {
  let returnVal = {
    root: {
      zIndex: 5000,
      padding: '1.25rem 1.25rem 1.25rem 1.75rem',
      '&::before': { backgroundColor: 'var(--error-dark)' },
      boxShadow:
        ' rgba(0, 0, 0, 0.05) 0px 0.0625rem 0.1875rem, rgba(0, 0, 0, 0.05) 0px 1.75rem 1.4375rem -0.4375rem, rgba(0, 0, 0, 0.04) 0px 0.75rem 0.75rem -0.437',
    },
    title: { fontSize: '1.33rem', marginBottom: '0.125rem' },
    description: { fontSize: '1.125rem' },
  };
  if (type == 'success') {
    returnVal.root['&::before'] = { backgroundColor: 'var(--success-dark)' };
  }
  return returnVal;
};

export const openNotification = (type: 'success' | 'danger', title: string = 'Title', message: string | null = 'Message') => {
  notifications.show({
    title,
    message,
    autoClose: 7000,
    styles: getStyles(type),
  });
};
